var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRedLithiumWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 156.435 34.595"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "RED LITHIUM"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32375"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32308"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32384",
  transform: "translate(0 -.001)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 156.435,
  height: 34.595,
  fill: "#fff",
  "data-name": "Rectangle 25681",
  rx: 2.487
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#57585b",
  "data-name": "Group 32374"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.865 20.019h3.833l-1.25 5.873c-.272 1.251.367 1.645 1.618 1.645s2.053-.394 2.325-1.645l1.25-5.873h3.834l-1.278 6.023c-.665 3.086-2.719 4.024-6.662 4.024s-5.615-.938-4.948-4.024Z",
  "data-name": "Path 17962"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.123 25.606c-1.808-.286-2.352-1.373-2.067-2.733.531-2.515 3.141-3.195 6.295-3.195 4.324 0 5.86 1.128 5.561 3.181h-4.46a.62.62 0 0 0-.422-.775 2.7 2.7 0 0 0-1.142-.2c-1.142 0-1.6.285-1.686.693-.054.272.027.449.394.5l4.432.68c1.877.285 2.883 1.183 2.529 2.828-.5 2.365-2.665 3.48-6.974 3.48-2.951 0-6.091-.408-5.493-3.263h4.623a.6.6 0 0 0 .258.693 2.84 2.84 0 0 0 1.264.2c1.2 0 1.591-.326 1.686-.788.055-.286-.054-.571-.557-.652Z",
  "data-name": "Path 17963"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.22 20.019h8.729c1.985 0 2.678.87 2.352 2.42a2.53 2.53 0 0 1-1.563 1.89v.027a1.78 1.78 0 0 1 1.183 2.216c-.394 1.9-1.618 3.154-4.459 3.154h-8.307Zm2.189 7.342h3.276c.762 0 1.061-.326 1.156-.761s-.068-.762-.829-.762h-3.277Zm.788-3.725h2.9c.775 0 1.006-.258 1.088-.639.081-.353-.041-.611-.816-.611h-2.9Z",
  "data-name": "Path 17964"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32373"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32370"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32368"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.836 6.193h4.3l-1.694 7.969h6.671l-.626 2.931H52.51Z",
  "data-name": "Path 17951"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.188 6.193h4.305l-2.321 10.9h-4.305Z",
  "data-name": "Path 17952"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.074 8.941h-3.985l.58-2.748h12.274l-.58 2.748h-3.984l-1.74 8.152h-4.305Z",
  "data-name": "Path 17953"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.846 12.742h-4.84l-.931 4.351h-4.3l2.321-10.9h4.3l-.809 3.8h4.839l.809-3.8h4.305l-2.32 10.9h-4.3Z",
  "data-name": "Path 17954"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.848 6.193h4.3l-2.321 10.9h-4.3Z",
  "data-name": "Path 17955"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.215 6.193h4.305l-1.4 6.595c-.305 1.4.412 1.848 1.816 1.848s2.306-.443 2.611-1.848l1.4-6.595h4.305l-1.435 6.763c-.748 3.465-3.053 4.519-7.48 4.519s-6.3-1.054-5.557-4.519Z",
  "data-name": "Path 17956"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.285 6.193h6.058l.443 6.335h.03l3.129-6.335h6.06l-2.32 10.9h-3.908l1.648-7.786h-.03l-3.938 7.786h-3.267l-.641-7.786h-.031l-1.648 7.786h-3.909Z",
  "data-name": "Path 17957"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32369"
}, /*#__PURE__*/React.createElement("path", {
  d: "M142.92 6.609h-1.1v2.9h-.864v-2.9h-1.094v-.694h3.053Zm4.585 2.9h-.783v-2.9h-.018l-1.042 2.9h-.463l-1.042-2.9h-.017v2.9h-.783v-3.6h1.264l.81 2.128.81-2.128h1.265Z",
  "data-name": "Path 17958"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32386"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32371"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#db011c",
  d: "m14.119 11.021 3.051-.007c.837 0 1.266-.33 1.406-1.02.181-.828-.313-1.027-1.024-1.025h-3Zm-3.293-4.789 9.068-.014a5.2 5.2 0 0 1 2.489.394 2.38 2.38 0 0 1 .919 2.64 3.12 3.12 0 0 1-2.191 2.488l-.021.031a1.37 1.37 0 0 1 .892 1.677l-.316 2.38a2.06 2.06 0 0 0 .261 1.284l-4.7.008a6.5 6.5 0 0 1 .208-2.059c.125-.808-.046-1.3-.842-1.3h-3.047l-.713 3.36-4.3.008Z",
  "data-name": "Path 17959"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#db011c",
  d: "m25.894 6.205 11.58-.019-.557 2.66-7.279.012-.322 1.467 6.764-.013-.557 2.657-6.765.012-.3 1.465 7.276-.012-.558 2.654-11.581.021Z",
  "data-name": "Path 17960"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32372"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#db011c",
  d: "M41.853 14.332h2.476a3.056 3.056 0 0 0 3.332-2.706c.367-1.729-.214-2.706-2.185-2.7h-2.473Zm-2.576-8.149 8.376-.015c3.7-.006 5.346 1.426 4.5 5.446-.8 3.833-3.087 5.454-6.7 5.46l-8.472.014Z",
  "data-name": "Path 17961"
}))))))));
export default SvgRedLithiumWhite;